@if (activeEditCategory || createNewCategory) {
  <div class="-mx-3">
    <service-category-create
      [activeCategory]="activeEditCategory"
      (close)="activeEditCategory = false; createNewCategory = false"
      (changed)="changedEditCategory($event)"
    />
  </div>
}

<div [ngClass]="{ hidden: activeEditCategory || createNewCategory }">
  <div
    class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mx-3 -mt-3"
    [ngClass]="{ hidden: activeEditCategory || createNewCategory }"
  >
    <div
      class="flex align-items-center"
      [ngClass]="{ hidden: activeEditCategory }"
    >
      <i class="fa-solid fa-wrench mr-2 text-500"></i>
      <h2 class="mb-0 text-sm">
        {{ 'ADMIN.SERVICES.MANGAGE_SERVICE_CATEGORIES' | translate }}
      </h2>
    </div>
    <i
      class="fa fa-times text-xl text-600 cursor-pointer"
      (click)="closeDialog()"
    ></i>
  </div>
  <!-- Header -->

  <!-- Content -->
  <div
    [ngClass]="{ hidden: activeEditCategory || createNewCategory }"
    class="py-3 text-sm -mx-3"
  >
    <div class="px-3 flex justify-content-between align-items-center">
      <div class="flex align-items-center w-8 md:w-6">
        <div class="mr-2">
          <div class="text-base">
            {{ 'ADMIN.COMMON.TOTAL' | translate }} -
            <strong>{{ tableData.getValue().length }}</strong>
            {{ 'ADMIN.SERVICES.SERVICES' | translate }}
          </div>
        </div>
      </div>
      <div
        class="w-4 md:w-6 flex align-items-center justify-content-end relative"
      >
        <div (click)="createNewCategory = true">
          <p-button
            styleClass="p-button-outlined text-sm hidden md:inline-block"
            icon="fa fa-plus"
            label="{{ 'ADMIN.SERVICES.SERVICE_CATEGORY_ADD' | translate }}"
          />
          <p-button
            styleClass="p-button-outlined text-sm md:hidden"
            icon="fa fa-plus"
          />
        </div>
      </div>
    </div>

    <div class="mt-2">
      @if (loading | async) {
        <div class="p-field p-col-12 p-md-6">
          <p-table [value]="[0, 1, 2, 3, 4, 5, 6]">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-items>
              <tr>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }

      <app-data-grid
        [hidden]="loading | async"
        [columnData]="tableData"
        [columns]="columns"
        [totalRecords]="totalRecordLength"
        [paginator]="false"
        [EmptyState]="emptyStateComponent$"
        [selectable]="selectAllAppCatData"
        (onAction)="onActionEvent($event)"
        [gridName]="'service-category-list'"
      />
    </div>
  </div>
</div>
